type DefaultSVGProps = {
    width: number
    height: number
}


export function ReplayButtonSVG(props: DefaultSVGProps){
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none">
            <path d="M7.27231 12L13 5.7775L11.3638 4L4 12L11.3638 20L13 18.2225L7.27231 12Z" fill="white" />
            <path d="M14.2723 12L20 5.7775L18.3638 4L11 12L18.3638 20L20 18.2225L14.2723 12Z" fill="white" />
        </svg>
    )
}

export function CloseButtonSVG(props: DefaultSVGProps){
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_265_18904)">
                <line x1="20.6919" y1="3.48214" x2="3.59079" y2="20.5832" stroke="white" strokeWidth="1.66154" strokeLinecap="round" />
                <line x1="3.5909" y1="3.96869" x2="20.692" y2="21.0698" stroke="white" strokeWidth="1.66154" strokeLinecap="round" />
            </g>
            <defs>
                <clipPath id="clip0_265_18904">
                    <rect width="22.1538" height="22.1538" fill="white" transform="translate(0.846191 0.923096)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export function HeartSVG(props: DefaultSVGProps){
    return (
        <svg {...props} viewBox="0 0 25 23" fill="none">
            <path d="M7.10534 1C10.9416 1 12.3002 3.9697 12.5 5.45455C12.6998 3.9697 14.0584 1 17.8947 1C22.6899 1 24.4882 6.72727 23.8888 9.27273C23.2894 14.3636 16.0965 19.4545 12.5 22C8.90354 19.4545 1.71063 14.3636 1.11125 9.27273C0.511836 6.72727 2.31006 1 7.10534 1Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export function ShareSVG(props: DefaultSVGProps){
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none">
            <path d="M12 15.75H9.6C5.45042 15.75 1.84744 18.1877 0.0388681 21.7634C0.0131161 21.4291 0 21.0911 0 20.75C0 13.8465 5.37258 8.25 12 8.25V2L24 12L12 22V15.75Z" fill="white" />
        </svg>
    )
}

export function SaveSVG(props: DefaultSVGProps){
    return (
        <svg {...props} viewBox="0 0 24 28" fill="none">
            <path d="M2.43696 28C2.06707 27.9986 1.70219 27.9146 1.36908 27.7541C0.96076 27.5627 0.615318 27.2596 0.372948 26.88C0.130578 26.5003 0.00124578 26.0599 0 25.6098V2.39039C0.00178398 2.07354 0.066336 1.76018 0.189944 1.46831C0.313552 1.17644 0.493777 0.911833 0.720254 0.689699C0.946731 0.467565 1.21499 0.292289 1.50961 0.173952C1.80423 0.0556145 2.11939 -0.0034499 2.43696 0.000155658H21.6041C22.2384 0.00374114 22.8457 0.25672 23.2943 0.7042C23.7428 1.15168 23.9964 1.75756 24 2.39039V25.6098C23.9911 26.0423 23.8647 26.4643 23.6343 26.8308C23.4039 27.1973 23.078 27.4946 22.6916 27.6908C22.3051 27.8871 21.8725 27.9751 21.4399 27.9453C21.0073 27.9156 20.5908 27.7693 20.235 27.522L12.2944 21.5805C12.2361 21.534 12.1636 21.5086 12.089 21.5086C12.0143 21.5086 11.9419 21.534 11.8836 21.5805L3.8745 27.522C3.45887 27.8305 2.95505 27.9981 2.43696 28ZM2.43696 2.04892C2.34619 2.04892 2.25913 2.0849 2.19494 2.14894C2.13075 2.21297 2.09469 2.29982 2.09469 2.39039V25.6098C2.09421 25.673 2.11205 25.7349 2.14605 25.7882C2.18006 25.8416 2.22879 25.8839 2.28637 25.9103C2.33877 25.9461 2.40082 25.9653 2.46435 25.9653C2.52788 25.9653 2.58992 25.9461 2.64233 25.9103L10.6515 19.9415C11.0679 19.6353 11.5717 19.4702 12.089 19.4702C12.6063 19.4702 13.1101 19.6353 13.5265 19.9415L21.4672 25.8829C21.5196 25.9188 21.5816 25.9379 21.6452 25.9379C21.7087 25.9379 21.7708 25.9188 21.8232 25.8829C21.8807 25.8566 21.9295 25.8142 21.9635 25.7609C21.9975 25.7076 22.0153 25.6456 22.0148 25.5825V2.39039C22.0159 2.33917 22.0053 2.28838 21.984 2.24178C21.9627 2.19517 21.9312 2.15395 21.8917 2.12116C21.8523 2.08836 21.806 2.06484 21.7562 2.05234C21.7064 2.03984 21.6544 2.03867 21.6041 2.04892H2.43696Z" fill="white"/>
        </svg>
    )
}

export function BackArrowSVG(props: DefaultSVGProps){
    return (
        <svg {...props} fill="#000000" viewBox="0 0 30.725 30.725"
        xmlSpace="preserve">
   <g>
       <path d="M24.078,26.457c0.977,0.978,0.977,2.559,0,3.536c-0.488,0.488-1.128,0.731-1.77,0.731c-0.639,0-1.278-0.243-1.768-0.731
           L5.914,15.362l14.629-14.63c0.977-0.977,2.559-0.976,3.535,0c0.977,0.977,0.977,2.56,0,3.536L12.984,15.362L24.078,26.457z"/>
   </g>
   </svg>

    )
}

export function SmilySVG(props: DefaultSVGProps){
    return (
        <svg {...props} viewBox="0 0 48 48" >
         <path d="M0 0h48v48H0z" fill="none"/>
            <g id="Shopicon">
                <circle cx="20" cy="18" r="2"/>
                <circle cx="28" cy="18" r="2"/>
                <path d="M24,32c4.411,0,8-3.589,8-8h-4c0,2.206-1.794,4-4,4s-4-1.794-4-4h-4C16,28.411,19.589,32,24,32z"/>
                <path d="M24,42c9.941,0,18-8.059,18-18S33.941,6,24,6C14.059,6,6,14.059,6,24S14.059,42,24,42z M24,10c7.72,0,14,6.28,14,14
                    c0,7.719-6.28,14-14,14c-7.72,0-14-6.281-14-14C10,16.28,16.28,10,24,10z"/>
            </g>
      </svg>
    )
}

export function ArrowDownSVG(props: DefaultSVGProps){
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C12.5523 3 13 3.44772 13 4V17.5858L18.2929 12.2929C18.6834 11.9024 19.3166 11.9024 19.7071 12.2929C20.0976 12.6834 20.0976 13.3166 19.7071 13.7071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L11 17.5858V4C11 3.44772 11.4477 3 12 3Z" fill="#000000"/>
        </svg>
    )
}